import CryptoJS from "crypto-js";
import axios from "axios";
import router from '../../router';

const state = {
  host: "localhost",
  proto: "https://",
  pwResetUrl: "/pwReset",
  project: process.env.VUE_APP_API_PROJECT,
  apiHost: process.env.VUE_APP_API_HOST,
  customUploads: "https://" + process.env.VUE_APP_API_HOST +  "/files",
  serverInfo: false,
  defaultAvatar: "c8d93d5e-b46b-415d-9970-2250c5248951",
  url() {
    return this.proto + this.apiHost + "/" + this.project;
  },
  currentToken: "",
  tokenLifeTime: 5,
  isAuthenticated: false,
  lastAuthCheck: false,
  isAdmin: false,
  authCheckThreshold: 5 * 60 * 1000,
  authHeader() {
    return { headers: { Authorization: "bearer " + window.localStorage.getItem("auth_token")} };
  },
  loginError: false,
  loginErrorMsg: false,
  status: "initial",
  endpoint: {
    auth: "/auth/authenticate",
    files: "/files",
    users: "/users",
    me: "/users/me",
    reqPwReset: "/auth/password/request",
    resetPw: "/auth/password/reset",
    refresh: "/auth/refresh",
    mail: "/mail",
  },
  user: false,
  userPw: false,
  userPwPlain: false,
  userImg: false,
  userImgFormats: {},
  userRole: false,
  uploadProgress: 0,
  pwResetRequested: false,
  kundeOfUser: false,
  connection: {
    monitoring: null,
    lastPingResult: null,
    redPings: 0,
    projectInfo: null,
    userInfo: null,
    checkInterval: null,
    checkIntervalTime: 10000,
    connectionRating: null,
  },
};

const defaultState = Object.assign({}, state);

const getters = {
  apiSettings: (state) => {
    return {
      url: state.url(),
      authHeader: state.authHeader(),
      endpoint: state.endpoint,
      customUploads: state.customUploads,
      apiHost: state.apiHost,
    };
  },
  apiToken: (state) => state.currentToken,
  isAuth: (state) => state.isAuthenticated,
  apiStatus: (state) => state.status,
  loginError: (state) => state.loginError,
  userImg: (state) => state.userImg,
  userImgFormats: (state) => state.userImgFormats,
  user: (state) => state.user,
  userRole: (state) => state.userRole,
  pwResetRequested: (state) => state.pwResetRequested,
  uploadProgress: (state) => state.uploadProgress,
  isAdmin: (state) => state.isAdmin,
  serverInfo: (state) => state.serverInfo,
  lastAuthCheck: (state) => state.lastAuthCheck,
  authCheckThreshold: (state) => state.authCheckThreshold,
  kou: (state) => state.kundeOfUser,
  defaultAvatar: (state) => state.defaultAvatar,
  connection: (state) => state.connection,
};

const actions = {
  async refreshToken({commit}) {
    commit("setToken", await this._vm.$directus.auth.token);
  },
  genPW() {
    return Math.random()
      .toString(36)
      .slice(-8);
  },
  handleConnectionLost({ dispatch }) {    
    //TODO: redirect
    if(state.isAuthenticated) {
      dispatch("logout");
      dispatch("msg/shutdown", null, {root:true});
      dispatch("chat/shutdownChat", null, {root:true})
      router.push("/").catch((error) => {
        console.log("logging out");
        console.log(error);
      });
    }

  },
  startConnectionMonitoring({ dispatch, commit }) {
    if (!state.connection.monitoring) {
      setInterval(startIt(), state.connection.checkIntervalTime);
    }
    function startIt() {
      dispatch("checkConnection");
      commit("startConnectionMonitoring");
    }
  },
  async checkConnection({ commit, dispatch }) {
    if (!state.isAuthenticated) {
      commit("clearConnectionInterval");
      return;
    }

    const pingStart = new Date();
    try {
      const pingResponse = await this._vm.$directus.server.ping();
      if (pingResponse !== "pong") dispatch("handleConnectionLost");
      if (state.isAuthenticated) {
        setTimeout(function() {
          dispatch("checkConnection");
        }, 5000);
      }
    } catch (err) {
      console.log("Error Pinging");
      dispatch("handleConnectionLost");
    }
    const pingEnd = new Date();
    const pingDiff = pingEnd - pingStart;

    commit("setLastPing", pingDiff);
    await dispatch("computeConnectionRating");

    if (!state.connection.projectInfo) {
      const pInfo = await this._vm.$directus.server.info();
      commit("setProjectInfo", pInfo);
    }
    if (!state.connection.userInfo) {
      const uInfo = await this._vm.$directus.users.me.read();
      commit("setUserInfo", uInfo);
    }
  },
  computeConnectionRating({ commit, dispatch }) {
    if (state.connection.lastPingResult < 400) {
      commit("setConnectionRating", "green"); //400
      commit("setRedPings", 0);
    }
    if (state.connection.lastPingResult > 400 && this.lastPingResult < 1200) {
      commit("setConnectionRating", "yellow"); //400
    }
    if (state.connection.lastPingResult > 1200){ //1200
      commit("setConnectionRating", "red");
      let lastReds = state.connection.redPings;
      var newReds = lastReds + 1;
      commit("setRedPings", newReds);
      if(state.connection.redPings >= 3) {
        dispatch("handleConnectionLost");
      }
    }
  },
  async logout({ commit }) {    
    await this._vm.$directus.auth.logout();
    commit("logout");
  },
  encryptPw({ commit }, creds) {
    let encrypted = false;
    try {
      encrypted = CryptoJS.AES.encrypt(creds, "iampwcrypt").toString();
    } catch (error) {
      console.log(error);
      throw error;
    }
    commit("setEncPw", encrypted);
  },
  decryptPw() {
    let decryptBytes = false;
    try {
      decryptBytes = CryptoJS.AES.decrypt(state.userPw, "iampwcrypt");
      let decryptString = decryptBytes.toString(CryptoJS.enc.Utf8);
      return decryptString;
    } catch (error) {
      console.log(error);
    }
  },
  //TODO: test
  async reqPwReset({ commit }, email) {
    try {
      //await directus.auth.password.request('admin@example.com');
      await this._vm.$directus.auth.password.request(email);
     // await this._vm.$directus.requestPasswordReset(email, state.host + state.pwResetUrl);
     console.log("Passed pwd reset request!");
      commit("setPwResetState");
    } catch (error) {
      throw error;
    }
  },
  async resetPw(_, payload) {
    try {
      await this._vm.$directus.auth.password.reset(payload.token, payload.password);
     // await this._vm.$directus.resetPassword(payload.password, payload.token);
    } catch (error) {
      throw error;
    }
  },
  async checkIfLoggedIn() {
    /*
        const storageExists = this._vm.$directus.api.config.token;
        if (storageExists) {
            console.log("found token, checking");
            try {
                const checkValid = await this._vm.$directus.getMe();
                console.log("output checkValid: ");
                console.log(checkValid);
                commit("initUser", checkValid.data);
                commit("refreshAuthCheck");
                if (checkValid.data.avatar) await dispatch("getUserImg", checkValid.data.avatar);
                return true;
            } catch (error) {
                console.log('token is invalid, returning to Login Page');
                dispatch("setDefaultState");
                commit("logout");
                this.$router.push("/");
            }
        } else {
            console.log('no token found or token invalid');
            return false;
        }*/
    return state.isAuthenticated;
  },
  async login({ commit, dispatch }, credentials) {
    state.loginError = false;
    try {

      //login user
      await this._vm.$directus.auth.login({
        email: credentials.email,
        password: credentials.password,
      });    
      

      //get current logged in user from db
      let user = await this._vm.$directus.users.me.read();
      //console.log(user);
      commit("initUser", user);
      commit("loginSuccess");

      //dispatch("manageTokenRefresh");

      if (user.role == 'f0995ff3-21fd-41a8-91fa-551469b0c5a6') {
        await dispatch("getKundeOfUser", user.id);
        await dispatch("handleLastLogin");
        await dispatch("getUserImg", state.kundeOfUser.image);
      } else {
        //get avatar image
        if (user.avatar) await dispatch("getUserImg", user.avatar);
      }
    } catch (error) {
      console.log(error);
      commit("loginFailure", error);
    }
  },
  async handleLastLogin({ dispatch }) {
    try {
      //prepare Date
      //const dOptions = { weekday: "numeric", year: "numeric", month: "numeric", day: "numeric", hour: "numeric", minute: "numeric" };
      const now = new Date();
      const localized = now.toLocaleString("de-DE");

      //check if logged in before
      if (state.kundeOfUser.last_login == null || state.kundeOfUser.last_login == "") {
        await dispatch("sendLastLoginMail", localized);
      }

      const payload = {
        collection: "kunde",
        item: state.kundeOfUser.id,
        changes: {
          last_login: localized,
        },
      };
      await dispatch("app/mutate", payload, { root: true });
    } catch (err) {
      console.log(err);
      throw "Fehler beim Aktualisieren des Login Status.";
    }
  },
  async sendLastLoginMail({ rootState }, logindate) {
    const token = await this._vm.$directus.auth.token;
    const url = rootState.app.mailerURL;
    const options = {
      headers: {
        Authorization: "bearer " + token,
      },
    };

    const subject = `${state.kundeOfUser.first_name} ${state.kundeOfUser.last_name} hat sich im Portal angemeldet`;
    const recipients = rootState.app.devMode ? rootState.app.devMail : "admins@infrabau-portal.de";
    const data = {
      to: recipients,
      from: "no-reply@infrabau-portal.de",
      subject: subject,
      body: `
          Hallo, <br/>
          <br />
          <span style='margin-top:20px; margin-bottom:20px;'>
          der Kunde ${state.kundeOfUser.first_name} ${state.kundeOfUser.last_name} hast sich zum ersten Mal im Portal angemeldet, der Zeitstempel lautet ${logindate}.          
          <br /><br />          
          <br /><br />
          <span style='margin-top:20px; margin-bottom:20px;'Infrabau Portal Mailer</span>
          `,
      type: "html",
      data: {
        vorname: state.kundeOfUser.first_name,
        nachname: state.kundeOfUser.last_name,
        login: logindate,
      },
    };

    try {
      await axios.post(url, data, options);
    } catch (error) {
      console.log("error when sending last login mail");
      console.log(error);
    }
  },
  async getKundeOfUser({ commit }, userId) {
    const filter = {
      filter: {
        user: userId,
      },
    };
    try {
      const responseKunde = await this._vm.$directus.items("kunde").readByQuery(filter);
      commit("setKundeOfUser", responseKunde.data[0]);
    } catch (error) {
      console.log(error);
      throw "Fehler beim Laden des Kundenbenutzers";
    }
  },
  async getUserImg({ commit, rootState, dispatch }, id) {
    if (id == null) id = rootState.chat.defaultAvatar;
    
    try {
      const payload = {
        id: id,
        mode: "imgtag",
        format: "thumb-100-full",
        volatile: false
      }

      const response = await dispatch("images/getImgURL", payload, { root: true });
      commit("setUserImg", response);
    } catch (error) {
      console.log("error fetching image");
      console.log(error);
    }
  },
  async uploadImage({ dispatch }, upload) {
    try {
      //old sdk
      const response = await this._vm.$directus.uploadFiles(upload.image, function onUploadProgress(prgEvent) {
        console.log(prgEvent);
      });
      const metadata = {
        tags: ["user_profile_image"],
      };

      await this._vm.$directus.files.updateOne(response.data.id, metadata);

      //UPLOAD image
    /*  const fileId = await directus.files.createOne(upload.image, function onUploadProgress(prgEvent) {
        console.log(prgEvent);
      }, metadata);*/

      dispatch("mutateUser", { avatar: response.data.id });
      dispatch("getUserImg", response.data.id);
    } catch (error) {
      console.log(error);
    }
  },
  async mutateUser({ commit }, changes) {
    try {
     let response = await this._vm.$directus.users.updateOne(state.user.id, changes);
      commit("initUser", response.data);
    } catch (error) {
      console.log(error);
    }
  },
  initUpdateUser({ commit }, changes) {
    commit("updateUserState", changes);
  },
  debug() {
    console.log(defaultState);
  },
  setDefaultState({ commit }) {
    commit("app/setDefaultState", null, { root: true });
    commit("logout");
  },
};

const mutations = {
  loginSuccess: (state) => {
    state.isAuthenticated = true;
    state.lastAuthCheck = new Date();
    state.loginErrorMsg = false;
    state.loginError = false;
    console.log("user role:");
    console.log(state.user);
    console.log(state.user.role);
    if (state.user.role == "0ef37112-08ae-4f6a-b727-12f6b0d8b964") {
      state.isAdmin = true;
    }
  },
  refreshAuthCheck: (state) => {
    state.lastAuthCheck = new Date();
  },
  loginFailure: (state, error) => {
    state.isAuthenticated = false;
    state.loginError = true;
    state.loginErrorMsg = error;
  },
  initUser: (state, user) => {
    state.user = user;
  },
  setUserImg: (state, img) => {
    
    state.userImg = img.url;
  },
  updateUserState(state, newState) {
    Object.assign(state.user, newState);
  },
  logout: (state) => {
    state.isAuthenticated = false;    
    state = {};
  },
  setEncPw: (state, pw) => {
    state.userPw = pw;
  },
  setPlainPw: (state, pw) => {
    state.userPwPlain = pw;
  },
  setPwResetState: (state) => {
    state.pwResetRequested = true;
  },
  setKundeOfUser: (state, kou) => {
    state.kundeOfUser = kou;
  },
  clearConnectionInterval: (state) => {
    clearInterval(state.connection.checkInterval);
    state.connection.checkConnection = false;
    state.connection.monitoring = false;
  },
  setLastPing: (state, ping) => {
    state.connection.lastPingResult = ping;
  },
  setRedPings: (state, pings) => {
    state.connection.redPings = pings;
  },
  setConnectionRating: (state, rating) => {
    state.connection.connectionRating = rating;
  },
  setUserInfo: (state, info) => {
    state.connection.userInfo = info;
  },
  setProjectInfo: (state, info) => {
    state.connection.projectInfo = info;
  },
  startConnectionMonitoring: (state) => {
    state.connection.monitoring = true;
  },
  setToken: (state, token) => {
    state.currentToken = token;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
